import isMobile from "is-mobile";
import { listen, qs, add, remove } from "@fluorescent/dom";

import { section } from "@/glow";

const ei = {
  get: () => JSON.parse(localStorage.getItem("exitIntent")),
  set: val => localStorage.setItem("exitIntent", val),
};

const classes = {
  visible: "visible",
  hidden: "hidden",
  active: "active",
};

section("popup", {
  bodyListener: null,

  onLoad() {
    const closeBtn = qs("[data-close-icon]", this.container);
    const mobileTimeout = parseInt(this.container.dataset.mobileLandingTimeout);

    this.closeBtnHandler = listen(closeBtn, "click", e => this.close(e));

    if (!ei.get() && isMobile()) {
      setTimeout(() => {
        this._show();
      }, mobileTimeout);
    } else if (!ei.get() && !Shopify.designMode) {
      this.bodyListener = listen(
        document.body,
        "mouseout",
        this._mouseLeave.bind(this)
      );
    }
  },

  _mouseLeave(e) {
    if (!e.relatedTarget && !e.toElement) {
      this._show();
      this.bodyListener && this.bodyListener();
    }
  },

  close(e) {
    e.preventDefault();
    this._hide();
    ei.set(true);
  },

  _show() {
    add(this.container, classes.active);

    setTimeout(() => {
      add(this.container, classes.visible);
    }, 250);
  },

  _hide() {
    add(this.container, classes.hidden);
    remove(this.container, classes.visible);

    setTimeout(() => {
      remove(this.container, classes.active);
    }, 250);
  },

  onSelect() {
    this._show();
  },

  onDeselect() {
    this._hide();
  },

  onUnload() {
    this.closeBtnHandler();
  },
});
